import React from 'react';
import {Alert, Button, Checkbox, Form, Input, message} from 'antd';
import {UserOutlined, LockOutlined} from '@ant-design/icons';
import 'antd/dist/antd.css';
import style from './Login.module.css';
import Axios from "../../utils/axios";

// —— 中间分割线：双 S 轮胎车辙波浪路径 ——
const WAVE_AMP = 5;
const WAVE_PERIOD = 200;
const WAVE_SPAN = 2400;
const WAVE_STEPS = 16;

function wavePath(cx, cy, horizontal) {
    const step = WAVE_PERIOD / WAVE_STEPS;
    const n = Math.round(WAVE_SPAN / step);
    let d = '';
    for (let i = 0; i <= n; i++) {
        const t = step * i;
        const w = WAVE_AMP * Math.sin((2 * Math.PI * t) / WAVE_PERIOD);
        const x = horizontal ? t : cx + w;
        const y = horizontal ? cy + w : t;
        d += (i === 0 ? 'M' : 'L') + x.toFixed(2) + ' ' + y.toFixed(2);
    }
    return d;
}

const WAVE_V_LEFT = wavePath(6, 0, false);
const WAVE_V_RIGHT = wavePath(18, 0, false);
const WAVE_H_TOP = wavePath(0, 6, true);
const WAVE_H_BOTTOM = wavePath(0, 18, true);

class Login extends React.Component {
    state = {
        username: '',
        password: '',
        submitting: false,
        // 登录态失效原因（被同端顶号 / 过期），常驻展示在登录卡片内
        logoutReason: ''
    }

    componentDidMount() {
        let reason = window.sessionStorage.getItem("logoutReason");
        if (reason) {
            this.setState({logoutReason: reason});
            window.sessionStorage.removeItem("logoutReason");
        }
    }

    onSubmit = () => {
        // 防重复提交：重复点击/回车会连续登录两次，后一次会顶掉前一次的会话，
        // 若响应返回顺序颠倒，浏览器会保存到已失效的 token（表现为登录后立刻闪退）
        if (this.state.submitting) return;
        this.setState({submitting: true});
        Axios({
            method: 'post',
            url: '/login',
            data: {
                username: this.state.username,
                password: this.state.password,
                // 登录会话按端隔离：PC 端每账号最多 1 个，H5 端最多 1 个，互不影响
                clientType: 'pc',
            }
        }).then(res => {
            this.setState({submitting: false});
            if (res.status === 200) {
                if (res.data.code === 200) {
                    window.sessionStorage.setItem("token", res.data.data.token);
                    window.sessionStorage.setItem("userName", res.data.data.userName);
                    window.sessionStorage.setItem("userRole", res.data.data.userRole);
                    window.sessionStorage.setItem("isSend", res.data.data.isSend);
                    switch (res.data.data.userRole) {
                        case 0:
                            this.props.history.push("/home")
                            break;
                        case 1:
                            this.props.history.push("/order")
                            break;
                        case 2:
                            this.props.history.push("/order")
                            break;
                        case 3:
                            this.props.history.push("/order")
                            break;
                        case 4:
                            this.props.history.push("/order")
                            break;
                        case 5:
                            this.props.history.push("/order")
                            break;
                        case 6:
                            this.props.history.push("/order")
                            break;
                        case 7:
                        case 8:
                        case 9:
                            message.error("您没有权限登录!");
                            this.props.history.push("/login")
                            break;
                        default:
                            message.error("您没有权限登录!");
                            this.props.history.push("/login")
                            break;
                    }
                } else {
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                message.error(res.message);
            }
        }).catch(err => {
            this.setState({submitting: false});
            console.log(err);
        });
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    render() {
        return (
            <div className={style.loginPage}>
                {/* 左侧：薄荷绿主题区 */}
                <div className={style.leftPanel}>
                    <svg className={`${style.deco} ${style.deco1}`} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <rect x="8" y="8" width="104" height="104" rx="26" stroke="rgba(255,255,255,0.42)" strokeWidth="1.5" />
                    </svg>
                    <svg className={`${style.deco} ${style.deco2}`} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <rect x="6" y="6" width="68" height="68" rx="18" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" />
                    </svg>
                    <svg className={`${style.deco} ${style.deco3}`} viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <rect x="10" y="10" width="130" height="130" rx="32" stroke="rgba(255,255,255,0.45)" strokeWidth="1.5" />
                    </svg>
                    <svg className={style.car} viewBox="0 0 200 90" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M16 68 Q14 60 22 59 L36 59 L46 43 Q50 37 60 36 L132 35 Q142 36 149 43 L155 59 L178 59 Q188 60 188 69 L188 74 Q188 77 184 77 L16 77 Q12 77 12 74 L12 70 Z" stroke="rgba(255,255,255,0.85)" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
                        <circle cx="50" cy="72" r="11" stroke="rgba(255,255,255,0.85)" strokeWidth="2" />
                        <circle cx="151" cy="72" r="11" stroke="rgba(255,255,255,0.85)" strokeWidth="2" />
                    </svg>
                    <div className={style.brand}>
                        <h1 className={style.title}>验车预约平台</h1>
                        <p className={style.subtitle}>车辆检测｜车况核验｜贴心车辆服务</p>
                    </div>
                </div>

                {/* 中间：轮胎胎面载入分割线 */}
                <div className={style.divider} aria-hidden="true">
                    <svg className={style.waveV} width="24" height={WAVE_SPAN} xmlns="http://www.w3.org/2000/svg" fill="none">
                        <path d={WAVE_V_LEFT} stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d={WAVE_V_RIGHT} stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <svg className={style.waveH} width={WAVE_SPAN} height="24" xmlns="http://www.w3.org/2000/svg" fill="none">
                        <path d={WAVE_H_TOP} stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d={WAVE_H_BOTTOM} stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>

                {/* 右侧：淡粉登录表单区 */}
                <div className={style.rightPanel}>
                    <svg className={`${style.decoR} ${style.decoR1}`} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <rect x="6" y="6" width="78" height="78" rx="20" stroke="rgba(148,212,194,0.4)" strokeWidth="1.4" />
                    </svg>
                    <svg className={`${style.decoR} ${style.decoR2}`} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <rect x="6" y="6" width="48" height="48" rx="14" stroke="rgba(148,212,194,0.35)" strokeWidth="1.4" />
                    </svg>

                    <div className={style.content}>
                        <div className={style.logoWrap}>
                            <img className={style.logo} src="/logo.png" alt="JWS"/>
                        </div>
                        <div className={style.cardHead}>
                            <div className={style.cardTitle}>验车预约平台</div>
                            <div className={style.cardSub}>Vehicle Appointment Service Platform</div>
                        </div>
                        {this.state.logoutReason ? (
                            <Alert
                                type="warning"
                                showIcon
                                closable
                                style={{marginBottom: 16, textAlign: 'left'}}
                                message={this.state.logoutReason}
                                onClose={() => this.setState({logoutReason: ''})}
                            />
                        ) : null}
                        <Form onFinish={this.onSubmit}>
                            <Form.Item
                                rules={[
                                    {required: true, message: '请输入账户!'},
                                ]}
                                name="usernameItem"
                            >
                                <Input
                                    size="large"
                                    prefix={<UserOutlined className="site-form-item-icon"/>}
                                    placeholder="Username"
                                    name="username"
                                    onChange={this.handleChange}
                                />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    {required: true, message: '请输入密码!'},
                                ]}
                                name="passwordItem"
                            >
                                <Input.Password
                                    size="large"
                                    type="password"
                                    name="password"
                                    prefix={<LockOutlined className="site-form-item-icon"/>}
                                    placeholder="Password"
                                    onChange={this.handleChange}
                                />
                            </Form.Item>
                            <div className={style.rememberRow}>
                                <Checkbox>记住账号</Checkbox>
                                <a className={style.forgetLink} onClick={() => this.props.history.push('/forgetPwd')}>忘记密码</a>
                            </div>
                            <Form.Item className={style.loginItem}>
                                <Button
                                    className={style.loginButton}
                                    htmlType="submit"
                                    loading={this.state.submitting}
                                >
                                    <span className={style.btnInner}>
                                        <svg className={style.btnCar} viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path d="M2.2 10.4 L2.2 8.7 Q2.2 8 2.8 7.9 L4 7.9 L5.1 5.8 Q5.4 5.4 5.9 5.4 L17.9 5.4 Q18.4 5.4 18.7 5.8 L19.8 7.9 L21.2 7.9 Q21.8 8 21.8 8.7 L21.8 10.4 Q21.8 10.7 21.5 10.7 L2.5 10.7 Q2.2 10.7 2.2 10.4 Z" stroke="#ffffff" strokeWidth="1.5" strokeLinejoin="round" />
                                            <circle cx="6" cy="10.6" r="1.7" stroke="#ffffff" strokeWidth="1.5" />
                                            <circle cx="18" cy="10.6" r="1.7" stroke="#ffffff" strokeWidth="1.5" />
                                        </svg>
                                        登录
                                    </span>
                                </Button>
                            </Form.Item>
                        </Form>
                        <div className={style.copyright}>©2026 验车预约平台 版权所有</div>
                    </div>
                    <div className={style.bottomHint}>内部业务系统，请使用授权账号登录</div>
                </div>
            </div>
        )
    }
}

export default Login;
